import product1 from "../../images/Ira.jpg";
import product2 from "../../images/Aditya.jpg";
import product3 from "../../images/devashish.jpg";
import product4 from "../../images/Rahul.jpeg";
import product5 from "../../images/Arya_Madan.jpg";
import product6 from "../../images/Saksham.jpg";
import product7 from "../../images/Himanshu.PNG";
import product8 from "../../images/Srishti.jpg";
import product9 from "../../images/Esha_Goel.jpg";
import product10 from "../../images/Parichit_Bhasin.jpg";
import product11 from "../../images/saumya.jpg";
import product12 from "../../images/ayushi.jpg";
import sweet1 from "../../images/sweet3.jpg";
import sweet2 from "../../images/sweet-2.jpg";
import sweet3 from "../../images/sweet-3.jpg";

export const productData = [
  {
    img: product1,
    alt: "Ira Pandey",
    name: "Ira Pandey",
    desc: `B.Tech.(CSE), GGSIPU | Blogger | Founder, Collegegiri `,
    price: "$19.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/ira-pandey-hmr/",
  },
  {
    img: product2,
    alt: "Aditya Gusain",
    name: "Aditya Gusain",
    desc: "B.Tech.(CSE), GGSIPU | Web Developer (CTO) ",
    price: "$16.99",
    button: `Connect`,
    url: "http://www.linkedin.com/in/adityagusain",
  },
  {
    img: product3,
    alt: "Devashish Bhandari",
    name: "Devashish Bhandari",
    desc: "B.Tech.(CSE), GGSIPU | Graphic Designer (Marketing Head)",
    price: "$14.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/devashish-bhandari/",
  },
  {
    img: product12,
    alt: "Ayushi",
    name: "Ayushi",
    desc: "B.Tech.(CSE) GGSIPU | Graphic Designer | Social Media Marketing",
    price: "$14.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/ayushi-tiwari-0375b6195/",
  },
  {
    img: product11,
    alt: "Saumya",
    name: "Saumya",
    desc:
      "B.Tech.(CSE) GGSIPU | Tech Blogger | Web Developer | Content Curator",
    price: "$14.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/saumyakushwah/",
  },
  {
    img: product8,
    alt: "Srishti Maggo",
    name: "Srishti Maggo",
    desc:
      "B.Tech.(CSE), GGSIPU | Microsoft Learning Student Ambassdor | Graphic Designer",
    price: "$14.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/srishti-maggo-668b9218a/",
  },
  {
    img: product5,
    alt: "Arya Madan",
    name: "Arya Madan",
    desc: "BBA IGDTUW | Co-Founder at MUDRA Society | Video Editor | YouTuber",
    price: "$16.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/arya-madan-3b8048188/",
  },
  {
    img: product10,
    alt: "Parichit Bhasin ",
    name: "Parichit Bhasin ",
    desc:
      "Eco (Hons.), DU | Team Leader at The Education Tree | Motivator and Public Speaker",
    price: "$14.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/parichit-bhasin-516625192/",
  },
  // {
  //   img: product6,
  //   alt: "Saksham Kapoor",
  //   name: "Saksham Kapoor",
  //   desc: "B.Tech.(CSE), NSUT | Web and Software Developer | Freelancer",
  //   price: "$14.99",
  //   button: "Connect",
  //   url: "https://www.linkedin.com/in/saksham-kapoor/",
  // },
  {
    img: product4,
    alt: "Rahul Joshi",
    name: "Rahul Joshi",
    desc: "B.Tech.(CSE), GGSIPU | Front-End Web Developer",
    price: "$19.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/rahul-joshi-997b93200/",
  },
  // {
  //   img: product9,
  //   alt: "Esha Goel",
  //   name: "Esha Goel",
  //   desc: "B.Tech.(COE) | NSUT | Competitive Programming ",
  //   price: "$14.99",
  //   button: "Connect",
  //   url: "https://www.linkedin.com/in/esha-goel",
  // },
  {
    img: product7,
    alt: "Himanshu",
    name: "Himanshu",
    desc: "B.Tech.(CSE) GGSIPU | Web Developer | Open Source Contributer",
    price: "$14.99",
    button: "Connect",
    url: "https://www.linkedin.com/in/himanshu-jaidka-b39b191a4/",
  },
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: "Donuts",
    name: "Doughlicious",
    desc:
      "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
    price: "$9.99",
    button: "Add to Cart",
  },
  {
    img: sweet3,
    alt: "Ice Cream",
    name: "Caramel Wonder",
    desc:
      "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
    price: "$12.99",
    button: "Add to Cart",
  },
  {
    img: sweet1,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "$9.99",
    button: "Add to Cart",
  },
];
